export default __webpack_public_path__ + "static/media/PC-08.ff571a13.jpg";